import React, { useEffect, useState } from "react";
import {
  CardHeader,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextareaAutosize,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import InputLabel from "@mui/material/InputLabel";
import { LoadingButton } from "@mui/lab";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";

const Sweepstakes = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.Sweepstakes;

  const [vchDescriptionEditor, setVchDescriptionEditor] = useState(() => {
    if (data?.vchDescription) {
      const contentBlock = htmlToDraft(data?.vchDescription);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  });
  const [vchDisclaimerEditor, setVchDisclaimerEditor] = useState(() => {
    if (data?.vchDisclaimer) {
      const contentBlock = htmlToDraft(data?.vchDisclaimer);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  });

  const handleDescriptionChange = (stateValue) => {
    setVchDescriptionEditor(stateValue);
    const val = draftToHtml(
      convertToRaw(vchDescriptionEditor.getCurrentContent())
    );
    handleChange("Sweepstakes", "vchDescription", val);
  };
  const handleDisclaimerChange = (stateValue) => {
    setVchDisclaimerEditor(stateValue);
    const val = draftToHtml(
      convertToRaw(vchDisclaimerEditor.getCurrentContent())
    );
    handleChange("Sweepstakes", "vchDisclaimer", val);
  };

  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">Sweepstakes</div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p>
                Do you want to display a sweepstake button on tour shop page ?{" "}
                <RadioGroup
                  row
                  name="bitSweepstakes"
                  id="bitSweepstakes"
                  value={data?.bitSweepstakes?.toString()}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) =>
                    handleChange(
                      "Sweepstakes",
                      "bitSweepstakes",
                      parseInt(e.target.value)
                    )
                  }
                >
                  <FormControlLabel
                    value={"1"}
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"Yes"}</span>}
                    className="bitSweepstakes"
                  />
                  <FormControlLabel
                    value={"0"}
                    className="bitSweepstakes"
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"No"}</span>}
                  />
                </RadioGroup>
              </p>
            </Grid>
            <Grid item xs={12}>
              <div className="flex items-end">
                <p className="text-md pt-2">
                  <b className="text-[#D41042]">Sweepstakes Url:</b>
                </p>
                <a
                  href={data?.vchStoreLinkURL}
                  target="_blank"
                  className="underline text-[#002EA5]"
                >
                  {data?.vchStoreLinkURL}
                </a>
              </div>
            </Grid>
            <Grid item xs={12}>
              <InputLabel
                className="text-base font-bold text-[#24211F]"
                htmlFor="vchHeadline"
              >
                Headline text
              </InputLabel>
              <TextField
                fullWidth
                variant="outlined"
                value={data?.vchHeadline}
                name="vchHeadline"
                id="vchHeadline"
                onChange={(e) =>
                  handleChange("Sweepstakes", "vchHeadline", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12}>
              <InputLabel
                className="text-base font-bold text-[#24211F]"
                htmlFor="vchDescription"
              >
                Description
              </InputLabel>
              <Editor
                editorState={vchDescriptionEditor}
                onEditorStateChange={handleDescriptionChange}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "textAlign",
                    "history",
                    "colorPicker",
                  ],
                  inline: {
                    options: ["italic", "bold", "underline"],
                    bold: { className: "demo-option-custom" },
                    italic: { className: "demo-option-custom" },
                    underline: { className: "demo-option-custom" },
                    strikethrough: { className: "demo-option-custom" },
                    monospace: { className: "demo-option-custom" },
                    superscript: { className: "demo-option-custom" },
                    subscript: { className: "demo-option-custom" },
                  },
                  blockType: {
                    className: "demo-option-custom-wide",
                    dropdownClassName: "demo-dropdown-custom",
                  },
                  fontSize: { className: "demo-option-custom-medium" },
                }}
              />
              {/* <TextareaAutosize
                style={{ width: "100%" }}
                id="vchDescription"
                variant="outlined"
                value={data?.vchDescription}
                minRows={3}
                onChange={(e) =>
                  handleChange("Sweepstakes", "vchDescription", e.target.value)
                }
              /> */}
            </Grid>
            <Grid item xs={12}>
              <InputLabel
                className="text-base font-bold text-[#24211F]"
                htmlFor="vchDisclaimer"
              >
                Legal Disclaimer
              </InputLabel>
              {/* <TextareaAutosize
                style={{ width: "100%" }}
                id="vchDisclaimer"
                variant="outlined"
                value={data?.vchDisclaimer}
                minRows={3}
                onChange={(e) =>
                  handleChange("Sweepstakes", "vchDisclaimer", e.target.value)
                }
              /> */}
              <Editor
                editorState={vchDisclaimerEditor}
                onEditorStateChange={handleDisclaimerChange}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "textAlign",
                    "history",
                    "colorPicker",
                  ],
                  inline: {
                    options: ["italic", "bold", "underline"],
                    bold: { className: "demo-option-custom" },
                    italic: { className: "demo-option-custom" },
                    underline: { className: "demo-option-custom" },
                    strikethrough: { className: "demo-option-custom" },
                    monospace: { className: "demo-option-custom" },
                    superscript: { className: "demo-option-custom" },
                    subscript: { className: "demo-option-custom" },
                  },
                  blockType: {
                    className: "demo-option-custom-wide",
                    dropdownClassName: "demo-dropdown-custom",
                  },
                  fontSize: { className: "demo-option-custom-medium" },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardActions
        sx={{
          backgroundColor: "#FFF8F8",
          borderTop: "1px solid #C12637",
          height: "50px",
        }}
      >
        <Grid container>
          <Grid item xs={6}>
            <Button
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("Sweepstakes")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={loadingButton === "Sweepstakes" ? true : false}
              loading={loadingButton === "Sweepstakes" ? true : false}
              onClick={() => handleSave("Sweepstakes")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default Sweepstakes;
